import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type NodeQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type NodeQuery = { __typename?: 'Query', configuratorNode?: { __typename?: 'configuratorNode', id: string, node_attributes?: string | null | undefined, parent_id?: number | null | undefined, descendants_have_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, has_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, children: Array<{ __typename?: 'configuratorNode', id: string, node_attributes?: string | null | undefined, parent_id?: number | null | undefined, descendants_have_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, has_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, children: Array<{ __typename?: 'configuratorNode', id: string, node_attributes?: string | null | undefined, parent_id?: number | null | undefined, descendants_have_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, has_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, children: Array<{ __typename?: 'configuratorNode', id: string, node_attributes?: string | null | undefined, parent_id?: number | null | undefined, descendants_have_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, has_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, children: Array<{ __typename?: 'configuratorNode', id: string, node_attributes?: string | null | undefined, parent_id?: number | null | undefined, descendants_have_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, has_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, children: Array<{ __typename?: 'configuratorNode', id: string, node_attributes?: string | null | undefined, parent_id?: number | null | undefined, descendants_have_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, has_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, children: Array<{ __typename?: 'configuratorNode', id: string, node_attributes?: string | null | undefined, parent_id?: number | null | undefined, descendants_have_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, has_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, children: Array<{ __typename?: 'configuratorNode', id: string, node_attributes?: string | null | undefined, parent_id?: number | null | undefined, descendants_have_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, has_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, children: Array<{ __typename?: 'configuratorNode', id: string, node_attributes?: string | null | undefined, parent_id?: number | null | undefined, descendants_have_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, has_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, children: Array<{ __typename?: 'configuratorNode', id: string, node_attributes?: string | null | undefined, parent_id?: number | null | undefined, descendants_have_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined, has_nodes_of_presets?: Array<{ __typename?: 'configuratorNodePresetNode', preset_id: number, preset_node_id: number } | null | undefined> | null | undefined }> }> }> }> }> }> }> }> }> } | null | undefined };


export const NodeDocument = gql`
    query Node($id: ID!) {
  configuratorNode(id: $id) {
    id
    node_attributes
    parent_id
    descendants_have_nodes_of_presets {
      preset_id
      preset_node_id
    }
    has_nodes_of_presets {
      preset_id
      preset_node_id
    }
    children {
      id
      node_attributes
      parent_id
      descendants_have_nodes_of_presets {
        preset_id
        preset_node_id
      }
      has_nodes_of_presets {
        preset_id
        preset_node_id
      }
      children {
        id
        node_attributes
        parent_id
        descendants_have_nodes_of_presets {
          preset_id
          preset_node_id
        }
        has_nodes_of_presets {
          preset_id
          preset_node_id
        }
        children {
          id
          node_attributes
          parent_id
          descendants_have_nodes_of_presets {
            preset_id
            preset_node_id
          }
          has_nodes_of_presets {
            preset_id
            preset_node_id
          }
          children {
            id
            node_attributes
            parent_id
            descendants_have_nodes_of_presets {
              preset_id
              preset_node_id
            }
            has_nodes_of_presets {
              preset_id
              preset_node_id
            }
            children {
              id
              node_attributes
              parent_id
              descendants_have_nodes_of_presets {
                preset_id
                preset_node_id
              }
              has_nodes_of_presets {
                preset_id
                preset_node_id
              }
              children {
                id
                node_attributes
                parent_id
                descendants_have_nodes_of_presets {
                  preset_id
                  preset_node_id
                }
                has_nodes_of_presets {
                  preset_id
                  preset_node_id
                }
                children {
                  id
                  node_attributes
                  parent_id
                  descendants_have_nodes_of_presets {
                    preset_id
                    preset_node_id
                  }
                  has_nodes_of_presets {
                    preset_id
                    preset_node_id
                  }
                  children {
                    id
                    node_attributes
                    parent_id
                    descendants_have_nodes_of_presets {
                      preset_id
                      preset_node_id
                    }
                    has_nodes_of_presets {
                      preset_id
                      preset_node_id
                    }
                    children {
                      id
                      node_attributes
                      parent_id
                      descendants_have_nodes_of_presets {
                        preset_id
                        preset_node_id
                      }
                      has_nodes_of_presets {
                        preset_id
                        preset_node_id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNodeQuery__
 *
 * To run a query within a React component, call `useNodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNodeQuery(baseOptions: Apollo.QueryHookOptions<NodeQuery, NodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NodeQuery, NodeQueryVariables>(NodeDocument, options);
      }
export function useNodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NodeQuery, NodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NodeQuery, NodeQueryVariables>(NodeDocument, options);
        }
export type NodeQueryHookResult = ReturnType<typeof useNodeQuery>;
export type NodeLazyQueryHookResult = ReturnType<typeof useNodeLazyQuery>;
export type NodeQueryResult = Apollo.QueryResult<NodeQuery, NodeQueryVariables>;